/**
 * Сколько класть в корзину одним нажатием «В корзину»: минимальный заказ
 * товара (шлюз, миграция 422) или 1. Меньше минимального сервер не примет.
 */
export const orderQty = (product: { minOrderQty?: number } | null | undefined): number =>
	product?.minOrderQty && product.minOrderQty > 1 ? product.minOrderQty : 1;
